export default {
  SET_ALL_EXAMS(state, payload) {
    state.examsList = payload
  },
  SET_NEW_EXAM(state, payload) {
    if (state.examsList.data.length < 10) state.examsList.data.push(payload)
  },
}
